export default "__VITE_ASSET__iiCAWzGh__"